import Vue from 'vue'
import Router from 'vue-router'
import home from './../pages/home'
import content from './../pages/content'
import join from './../pages/join'
import partner from './../pages/partner'
import about from './../pages/about'

Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/content',
      name: 'content',
      component: content
    },
    {
      path: '/content/join',
      name: 'join',
      component: join,
    },
    {
      path: '/partner',
      name: 'partner',
      component: partner,
    },
    {
      path: '/about',
      name: 'about',
      component: about,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/client/router/index.js